<template>
    <div id="uptimecontainer">
        <div v-if="!reports_checkstatus.reportUptime">
            <h3>Loading uptime...</h3>
        </div>
        <div v-else-if="!isRunning" class="inactive">Check is not active.</div>
        <v-card v-else class="uptime">
            <v-card-text >
                <div class='cardtitle'>Uptime</div>
                <div v-if="isGauge"  class="uptimegraph uptimedata">
                    <GChart
                        :settings="{ packages: ['corechart', 'gauge'] }"
                        type="Gauge"
                        :data="gaugeData()"
                        :options="gaugeOptions"
                    />
                    <v-overlay light absolute="true" v-if="thestledown">N/A</v-overlay>
                    <v-row v-if="checkAge() < 30" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
                <div v-else-if="mergedConfig.uptimespan === 'Uptime for seven days'" class="uptimedata">
                    <v-row>
                        <h3>7 Days Uptime: {{ formatUptime(reports_checkstatus.reportUptime && reports_checkstatus.reportUptime.total && reports_checkstatus.reportUptime.total.uptime) }}</h3>
                    </v-row>
                    <v-row justify="space-between">
                        <v-col class="s6 text-no-wrap" cols="12" md="1">
                            Date:<br />
                            Uptime:
                        </v-col>
                        <v-col class="s6 text-no-wrap" cols="12" md="1" v-for="(day) in sevenDays" v-bind:key="day" >
                            <!-- {{idx}} {{day}} {{job.uptime[day]}} -->
                            {{ formatDay(day) }}<br />
                            {{ formatUptime(reports_checkstatus.reportUptime[day] && reports_checkstatus.reportUptime[day].uptime) }}
                        </v-col>
                    </v-row>
                    <v-row v-if="checkAge() < 7" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
                <div v-else-if="mergedConfig.uptimespan === 'Uptime for today'" class="uptimedata">
                    <v-row>
                        <h3>Today's Uptime: {{ formatUptime(reports_checkstatus.reportUptime && reports_checkstatus.reportUptime.total && reports_checkstatus.reportUptime.total.uptime) }}</h3>
                    </v-row>
                </div>
                <div v-else-if="mergedConfig.uptimespan === 'Uptime for today and 30 days'" class="uptimedata">
                    <v-row class="d-flex flex-wrap">
                        <div class="col-md-6 col-sm-12">
                            <label class="uptimelabel">Today's Uptime:</label>
                            <span class="uptimevalue" >{{ formatUptime(reports_checkstatus.reportUptime[now.date].uptime) }}</span>
                        </div>
                        <div class="align-right col-md-6 col-sm-12">
                            <label class="uptimelabel">30 Days Uptime:</label>
                            <span
                                class="uptimevalue"
                            >{{ formatUptime(reports_checkstatus.reportUptime && reports_checkstatus.reportUptime.total && reports_checkstatus.reportUptime.total.uptime) }}</span>
                        </div>
                    </v-row>
                    <v-row v-if="checkAge() < 30" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
                <div v-else-if="mergedConfig.uptimespan === 'Uptime for one, three, seven and 30 days'" class="uptimedata">
                    <v-row class="d-flex flex-wrap">
                        <div class="col-md-3 col-sm-6">
                            <label class="uptimelabel-4">Today's Uptime:</label><br />
                            <span class="uptimevalue" >{{ formatUptime(onethree.one.uptime) }}</span>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <label class="uptimelabel-4">Three Days:</label><br />
                            <span class="uptimevalue" >{{ formatUptime(onethree.three.uptime) }}</span><span style="display:none">{{ onethree.three.parts }}</span>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <label class="uptimelabel-4">Seven Days:</label><br />
                            <span class="uptimevalue" >{{ formatUptime(onethree.seven.uptime) }}</span><span style="display:none">{{ onethree.seven.parts }}</span>
                        </div>
                        <div class="align-right col-md-3 col-sm-6">
                            <label class="uptimelabel-4">30 Days:</label><br />
                            <span class="uptimevalue" >{{ formatUptime(onethree.thirty.uptime) }}</span>
                        </div>
                    </v-row>
                    <v-row v-if="checkAge() < 30" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
                <div v-else-if="mergedConfig.uptimespan === 'Monthly Uptime'" class="uptimedata">
                    <v-row>
                        <h3>Uptime for Past Year: {{ formatUptime(reports_checkstatus.reportUptime.total.uptime) }}</h3>
                    </v-row>
                    <v-row class="d-flex flex-wrap">
                        <v-col class="s6 text-no-wrap" cols="12" md="1" v-for="(day) in twelveMonths" v-bind:key="day.key" >
                            {{day.year}}<br />
                            {{day.month}}<br />
                            {{ formatUptime(reports_checkstatus.reportUptime[day.key] && reports_checkstatus.reportUptime[day.key].uptime) }}
                        </v-col>
                    </v-row>
                    <v-row v-if="checkAge() < 30" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
                <div v-else class="uptimedata">
                    <v-row>
                        <h3>30 Days Uptime: {{ formatUptime(reports_checkstatus.reportUptime && reports_checkstatus.reportUptime.total && reports_checkstatus.reportUptime.total.uptime) }}</h3>
                    </v-row>
                    <v-row justify="space-between">
                        <v-col class="s6 text-no-wrap" cols="12" md="1">
                            Date:<br />
                            Uptime:
                        </v-col>
                        <v-col class="s6 text-no-wrap" cols="12" md="1" v-for="(day) in sevenDays" v-bind:key="day" >
                            {{ formatDay(day) }}<br />
                            {{ formatUptime(reports_checkstatus.reportUptime[day] && reports_checkstatus.reportUptime[day].uptime) }}
                        </v-col>
                    </v-row>
                    <v-row v-if="checkAge() < 30" class='uptimenote'>
                        This check was created on {{ formatDate(reports_checkstatus.reportCheck.created) }}, so Uptime is only available for {{checkAge()}} days.
                    </v-row>
                </div>
            </v-card-text>
        </v-card>

        <div style="display:none">
            <code>{{ reports_checkstatus.reportUptime }}</code>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    format as date_format,
    parse as date_parse,
    differenceInDays,
    subDays,
    subMonths
} from "date-fns";
import { formatDay } from "../lib/filter";
import { GChart } from 'vue-google-charts';
import _round from "lodash/round";

// uptimespanoptions: [
//     "Uptime for seven days",
//     "Uptime for seven days + 30 days",
//     "Uptime for today",
//     "Uptime for today and 30 days",
//     "Monthly Uptime"
// ]



export default {
    name: "ReportUptime",
    props: {
        runpolling: {
            type: Boolean,
            default: false
        },
        reportid: {
            type: String
        }
    },
    components: { GChart },
    data() {
        return {
            thestledown: false,
            gaugeOptions: {
                width: 600,
                height: 180,
                redColor: "#f03d15", redFrom: 0, redTo:90,
                yellowColor: '#f60', yellowFrom: 90, yellowTo: 98,
                greenColor: '#366836',greenFrom: 98, greenTo: 100
            }
        };
    },
    computed: {
        ...mapState(["reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        isRunning: function() {
            return (
                this.reports_checkstatus.reportCheck.enable === "active" &&
                this.reports_checkstatus.reportCheck.state !== undefined
            );
        },
        sevenDays: function() {
            if (!this.now) return;
            let days = [this.now.date];
            let dateobj = date_parse(this.now.date);
            for (let i = 1; i < 7; i++) {
                days.push(date_format(subDays(dateobj, i), "YYYY-MM-DD")); // we need this format to use the uptime data
            }
            return days;
        },
        twelveMonths: function() {
            if (!this.now) return;
            let days = [];
            let dateobj = date_parse(this.now.date);
            days.push({
                key: date_format(dateobj, "YYYY-MM"),
                year: date_format(dateobj, "YYYY"),
                month: date_format(dateobj, "MMM")
            });
            for (let i = 1; i < 12; i++) {
                let day = subMonths(dateobj, i);
                days.push({
                    key: date_format(day, "YYYY-MM"),
                    year: day.getMonth() === 11 ? date_format(day, "YYYY") : "",
                    month: date_format(day, "MMM")
                }); // we need this format to use the uptime data
            }
            return days;
        },
        onethree: function(){
            if(this.mergedConfig.uptimespan !== "Uptime for one, three, seven and 30 days" && this.mergedConfig.uptimespan !== "Gauge for one, three, seven and 30 days") return false;

            let today = this.now.date;
            let dateobj = date_parse(today);
            let three = date_format(subDays(dateobj, 2), "YYYY-MM-DD");
            let seven = date_format(subDays(dateobj, 6), "YYYY-MM-DD");
            let thirty = date_format(subDays(dateobj, 30), "YYYY-MM-DD");
            let created = date_format(date_parse(this.reports_checkstatus.reportCheck.created), "YYYY-MM-DD");

            let uptime = {
                "one": this.reports_checkstatus.reportUptime[today],
                "three": { enabled: 0, down: 0, uptime: 0, parts: [], na: (three < created) },
                "seven": { enabled: 0, down: 0, uptime: 0, parts: [], na: (seven < created) },
                "thirty": this.reports_checkstatus.reportUptime.total,
                "total": this.reports_checkstatus.reportUptime.total
            };
            uptime.one.na = (this.reports_checkstatus.reportCheck.created > Date.now() - 43200000);  // at least 12 hours ago.
            uptime.thirty.na = (thirty < created);
            uptime.total.na = uptime.thirty.na;

            for(let k in  this.reports_checkstatus.reportUptime){
                if(k === "total") continue;
                if(k >= three){
                    uptime.three.enabled += this.reports_checkstatus.reportUptime[k].enabled;
                    uptime.three.down += this.reports_checkstatus.reportUptime[k].down;
                    uptime.three.parts.push(k);
                }
                if(k >= seven){
                    uptime.seven.enabled += this.reports_checkstatus.reportUptime[k].enabled;
                    uptime.seven.down += this.reports_checkstatus.reportUptime[k].down;
                    uptime.seven.parts.push(k);
                }
            }

            uptime.three.uptime = (uptime.three.down) ? (100 - ((uptime.three.down / uptime.three.enabled) * 100)) : 100;
            uptime.seven.uptime = (uptime.seven.down) ? (100 - ((uptime.seven.down / uptime.seven.enabled) * 100)) : 100;

            // console.log('onethree', thirty, uptime);

            return uptime;
        },
        isGauge: function(){
            const gauges = [
                "Gauge for seven days",
                // "Gauge for seven days + 30 days",
                "Gauge for today",
                "Gauge for today and 30 days",
                "Gauge for one, three, seven and 30 days"
            ];
            return gauges.indexOf(this.mergedConfig.uptimespan) > -1;
        }
    },
    methods: {
        startPolling: function(options) {
            // console.log("Uptime polling started");
            clearTimeout(this.$options.polling);
            options = options || {};
            this.getUptime(options).then(() => {
                // console.log('events set?', this.reports_checkstatus.reportEvents);
                this.$options.polling = setTimeout(() => {
                    this.startPolling({ poll: true });
                }, 60000);
            });
        },
        stopPolling: function() {
            if (this.$options && this.$options.polling) {
                clearTimeout(this.$options.polling);
            }
        },
        gaugeData: function(options) {
            let span = (options && options.span) || options || this.mergedConfig.uptimespan;
            switch(span){
                case "Gauge for seven days":
                    return [
                        ["Label","Value"],
                        ["7 Days", (this.reports_checkstatus.reportUptime && this.reports_checkstatus.reportUptime.total &&  this.reports_checkstatus.reportUptime.total.uptime) || undefined]
                    ];
                case "Gauge for seven days + 30 days":
                    // data isn't right for this one.
                    return [["Label","Value"], ["7 Days", (this.reports_checkstatus.reportUptime && this.reports_checkstatus.reportUptime.total &&  this.reports_checkstatus.reportUptime.total.uptime) || undefined], ["30 Days", ]];
                case "Gauge for today":
                    return [
                        ["Label","Value"],
                        ["Today", this.reports_checkstatus.reportUptime[this.now.date].uptime]
                    ];
                case "Gauge for today and 30 days":
                    return [
                        ["Label","Value"],
                        ["Today", this.reports_checkstatus.reportUptime[this.now.date].uptime],
                        ["30 Days", this.reports_checkstatus.reportUptime.total.uptime]
                    ];
                case "Gauge for one, three, seven and 30 days":
                    return [
                        ["Label","Value"],
                        ["Today",   this.onethree.one.na ? null : this.onethree.one.uptime ],
                        ["3 Days",  this.onethree.three.na ? null : this.onethree.three.uptime ],
                        ["7 Days",  this.onethree.seven.na ? null : this.onethree.seven.uptime ],
                        ["30 Days", this.onethree.thirty.na ? null: this.onethree.total.uptime ]
                    ];

            }

        },
        getUptime: function(options) {
            options = options || {};
            let params = {
                reportid: this.reportid
            };

            return this.$store
                .dispatch("reports_checkstatus/getUptime", params)
                .then(() => {
                    // console.log("Uptime", this.reports_checkstatus.checkUptime);
                })
                .catch(e => {
                    console.log("error getting uptime", e);
                });
        },
        checkAge: function(){
            return 1 + differenceInDays(new Date, date_parse(this.reports_checkstatus.reportCheck.created));
        },
        formatUptime: function(val){
            if (val - 0 == val){
                // we want 0 and 100 to show without decimals, and everything else to be rounded to 2 digits of precision.
                val = _round(val,3); // this is to deal with some odd floating point issues that give us things like 0.0000000001
                if(val > 0 && val < 100) val = val.toFixed(3);
                return val + "%";
            } else {
                return "-";
            }
        },
        formatDay(val) {
            return date_format(date_parse(val), 'D MMM');
        },
        formatDate(val) {
            return date_format(date_parse(val), 'YYYY-MM-DD');
        }

    },
    watch: {
        runpolling: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log('runpolling handler in uptime', newVal, oldVal);
                if(newVal){
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            }
        }
    },
    beforeDestroy: function() {
        // console.log('uptime beforeDestroy');
        this.stopPolling();
    },
    deactivated: function () {
        // console.log('uptime deactivated');
        this.stopPolling();
    }
};
</script>

<style scoped>

/* .uptime {
    padding: 0 1em 0 0;
    margin-bottom: 1em;
    color: #ff6961;

    color: #55F;
    color: #77dd77;
    color: #366836;

    color: orange;
    color: #ffb347;
    color: #f60;
    color: #e65100;

    color: #f03d15;
    color: #933;


} */

.uptimedata {
    padding: 1em;
    margin-bottom: 1em;
}

.uptime .v-card__text {
    color: #111;
}

.uptimelabel {
    font-size: 1.1em;
    font-weight: bold;
    display: inline-block;
    margin-right: 1em;
    width: 40%;
}

.uptimelabel-4 {
    font-size: 1.1em;
    font-weight: bold;
    display: inline-block;
    margin-right: 1em;
}

.uptimevalue {
    display: inline-block;
    font-size: 1.1em;
    font-weight: bold;
}
</style>
<style >
.uptimegraph table {
    width: 100%;
}
.uptimenote {
    padding-top: 0.8em;
    margin-bottom: -2.2em
}
</style>